import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import MarketingLayout from "@/components/MarketingLayout";

export default function NotFound() {
  useEffect(() => {
    const prev = document.title;
    document.title = "Page not found | Sisterhood+";
    let meta = document.querySelector('meta[name="robots"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "robots");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", "noindex, follow");
    return () => { document.title = prev; };
  }, []);

  return (
    <MarketingLayout>
      <section className="max-w-[640px] mx-auto px-6 py-24 text-center" data-testid="notfound-page">
        <p className="font-heading text-7xl font-light text-[#C89B55]">404</p>
        <h1 className="font-heading text-3xl sm:text-4xl tracking-tight font-light mt-4">We couldn't find that page.</h1>
        <p className="mt-4 text-[#291B2D]/70 leading-relaxed">The page may have moved. Let's get you back to a good place.</p>
        <Link to="/" data-testid="notfound-home"
          className="mt-8 inline-flex items-center justify-center gap-2 bg-[#291B2D] text-white rounded-full px-7 py-3.5 font-medium hover:bg-[#352238] transition-smooth">
          Back to home <ArrowRight size={16} />
        </Link>
      </section>
    </MarketingLayout>
  );
}
